import { components } from 'react-select';
import styled from 'styled-components';

export const Menu = styled(components.Menu)`
  z-index: 10 !important;
  margin-top: 0px !important;
`;
